import { c as _c } from "react/compiler-runtime";
import React from 'react';
interface ErrorMessageProps {
  error: string;
  id?: string;
}
export function ErrorMessage(t0) {
  const $ = _c(3);
  const {
    error,
    id
  } = t0;
  let t1;
  if ($[0] !== error || $[1] !== id) {
    t1 = <span id={id} role="alert" className="mt-1 text-xs text-red-500">{error}</span>;
    $[0] = error;
    $[1] = id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}